var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "share_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.07.507h50v50h-50z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#share_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.647 7.612-5.678 6.016 29.852-1.012-24.174-5.004Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.97 13.909c-.112 0-.168-.056-.224-.169-.056-.112 0-.168.056-.28l5.622-6.016c.056-.056.169-.113.225-.056l24.174 5.003c.112 0 .224.112.168.281a.242.242 0 0 1-.225.225l-29.795 1.012c.056 0 .056 0 0 0Zm5.735-6.015-5.116 5.509 27.21-.956-22.094-4.553Z",
    fill: "#1E1C43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.827 12.616 19.02 33.473 10.7 19.981l39.127-7.365Z",
    fill: "#F5B826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.017 33.755c-.112 0-.169-.057-.225-.113l-8.32-13.549a.17.17 0 0 1 0-.224l.168-.169 39.128-7.308a.31.31 0 0 1 .281.168c.057.113 0 .225-.112.281L19.129 33.698s-.056.056-.112.056ZM11.09 20.15l7.983 13.042L48.7 13.122 11.09 20.15Z",
    fill: "#101C44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.825 12.616-43.175.562-6.353 6.69 3.485 2.418 46.043-9.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78 22.567c-.056 0-.112 0-.112-.057L.183 20.093c-.056-.056-.113-.113-.113-.169 0-.056 0-.168.057-.168l6.352-6.69c.056-.057.113-.057.169-.057l43.12-.562c.112 0 .224.113.224.225a.31.31 0 0 1-.169.281L3.781 22.567c.056 0 .056-.057 0 0ZM.69 19.812l3.148 2.192 43.457-9.107-40.534.506L.69 19.812ZM24.75 40.838s-7.196 3.542-8.433 2.53c-2.473-2.024-.787-6.858-.787-6.858l7.14-4.33s2.361 7.759 2.08 8.658Z",
    fill: "#1E1C43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.341 31.843s-2.08 5.229.169 11.806c5.734 0 10.4 0 12.874-.056s2.192-4.779 1.518-5.903c1.405-1.237 3.373-4.666 2.305-9.95 3.26-.62 7.252-.731 7.533-3.88 0-.337-.112-.674-.337-.843-1.012-.787-2.755-.843-5.453-.675-3.036.169-8.32.956-12.144 5.397l-3.485 3.88-2.98.224Z",
    fill: "#AD5BB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.213 25.49-9.782 6.578s-1.743 4.104.9 3.879c0 1.405.056 3.204 2.08 3.148-.394 1.293-.675 3.148 1.405 2.361 2.08-.787 5.06-3.766 6.353-5.903.787-2.417.45-3.148-.169-2.867.675-1.968 1.012-4.216-.562-4.441.225-2.024.225-2.024-.225-2.755Z",
    fill: "#AD5BB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.693 41.85h-.113a.242.242 0 0 1-.225-.225c0-.113.113-.282.225-.225.057 0 6.297.112 8.377-3.823.056-.113.225-.169.337-.113.113.057.169.225.113.338-2.137 3.879-7.815 4.047-8.714 4.047ZM22.333 36.228c-.113 0-.169-.056-.225-.113a.27.27 0 0 1 .112-.337c2.024-1.124 8.995-7.646 9.052-7.758.112-.113.224-.113.337 0 .112.112.112.225 0 .337-.281.281-7.027 6.634-9.164 7.815 0 .056-.056.056-.112.056ZM24.469 39.545a.426.426 0 0 1-.225-.113c-.056-.112-.056-.28.056-.337.056-.056 5.51-3.373 7.477-6.521.056-.113.225-.17.337-.057.113.057.17.225.057.338-2.024 3.26-7.421 6.577-7.646 6.69h-.056Z",
    fill: "#101C44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.827 34.316c-.057 0-.113 0-.113-.056-.112-.057-.112-.225-.056-.338.169-.224 1.405-2.023 2.586-1.911.45.056.787.337 1.068.9a.27.27 0 0 1-.112.337.27.27 0 0 1-.337-.113c-.17-.393-.394-.562-.675-.618-.787-.056-1.8 1.237-2.136 1.743-.057 0-.113.056-.225.056ZM23.68 37.408c-.056 0-.113 0-.169-.056-.112-.056-.112-.225-.056-.337.056-.056 1.124-1.518 2.417-1.63.506-.057 1.012.168 1.406.562.112.112.112.225 0 .337-.113.113-.225.113-.338 0-.28-.337-.618-.45-1.012-.45-1.068.056-2.023 1.406-2.08 1.406 0 .168-.056.168-.168.168ZM24.975 40.725c-.056 0-.112 0-.112-.056-.113-.056-.113-.225-.056-.337.056-.057 1.124-1.63 2.304-1.743.394-.056.787.112 1.125.45.112.112.112.224 0 .337-.113.112-.225.112-.338 0-.224-.225-.45-.281-.73-.281-.787.056-1.687 1.124-1.968 1.518-.056.112-.169.112-.225.112ZM26.607 24.421c-1.125 0-2.755-.168-3.036-1.012-.169-.45-.169-.73-.169-.73 0-.113.057-.281.225-.281.113 0 .281.056.281.224 0 0 0 .225.169.619.225.618 2.136.787 3.43.674.112 0 .224.113.28.225 0 .113-.112.225-.224.281-.17-.056-.506 0-.956 0Z",
    fill: "#101C44"
  }))));
};

export default SvgShare;